import { ampli } from 'lib-shared-tracking';

import { PartnerTrackingEventsProps } from '../partners.types';

export const rechargePartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('recharge:profile:received', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetProfileReceived(payload),
  );

  partnerEvents.on('recharge:external:customer:overview:opened', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetCustomerOverviewOpened(payload),
  );

  partnerEvents.on('recharge:external:order:opened', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetOrderOpened(payload),
  );

  partnerEvents.on('recharge:external:orders:list:opened', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetOrdersListOpened(payload),
  );
};
